export const formDefaultValues = {
  addTurnPaymentLinkOnAgendaCreate: false,
  addTurnPaymentLinkOnPatientCreate: false,
}
